import PropTypes from "prop-types";
import styled from "styled-components";

import { Placeholder } from "components/Placeholder";
import { Title } from "style/components/Title.styles";

const ATVChartPlaceholderContainer = styled.div`
  .custom-placeholder {
    min-height: ${({ height }) => height};
  }
`;

const AssetTradingVolumeChartPlaceholder = ({ height }) => {
  return (
    <ATVChartPlaceholderContainer height={height}>
      <div className="asset-trading-volume-chart">
        <Title className="mb-0">Asset Trading Volume</Title>
        <div className="divider my-3"></div>
        <div className="chart-container">
          <Placeholder className="custom-placeholder" />
        </div>
      </div>
    </ATVChartPlaceholderContainer>
  );
};

AssetTradingVolumeChartPlaceholder.propTypes = {
  height: PropTypes.string,
};

export { AssetTradingVolumeChartPlaceholder };
